function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
import sensors from 'sa-sdk-javascript';
import { getEnv } from "../utils";

/**
 * 神策初始化
 */
export var sensorsInit = function sensorsInit() {
  if (!getEnv()) {
    // 初始化神策统计
    sensors.init({
      name: 'sensors',
      server_url: 'https://gaodun.datasink.sensorsdata.cn/sa?project=jgxy_production&token=b9ea8de774df405c',
      is_track_single_page: true,
      // show_log: true,
      heatmap: {}
    });

    // 事件公共属性设置，在事件初始化后即刻调用，避免部分事件属性缺失
    sensors.registerPage({
      scrm_source: 'H5'
    });

    // 事件上报开关
    sensors.quick('autoTrack');
  }
};

/**
 * 登录后即刻调用，用于关联用户id
 * @param userId 高顿登录用户id
 */
export var sensorsLogin = function sensorsLogin(userId) {
  if (!getEnv() && userId) {
    sensors.quick('isReady', function () {
      sensors.login(userId.toString());
    });
  }
};

/**
 * 神策指定事件跟踪
 * @param fnName 事件名
 * @param params 事件属性
 */
export var sensorsTrack = function sensorsTrack(fnName) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!getEnv()) {
    sensors.quick('isReady', function () {
      sensors.track(fnName, _objectSpread(_objectSpread({}, params), {}, {
        scrm_source: 'H5'
      }));
    });
  }
};